import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import Header from './Header';
import WelcomeSection from './WelcomeSection';
import Footer from './Footer';
import ModulesSession from './Modules';
import VisionaryLeader from './VisionaryLeader';
import AboutUs from './AboutUs';
import ClientsSection from './Clients';
import KnowMore from './KnowMore';
import RegistrationSection from './RegistrationSection';
import SignUpCollege from './register';
import FAQ from './FAQ';
import ScrollToTop from './ScrollToTop';

const HomePage = () => {
    const history = useHistory();
	
    const [darkMode, setDarkMode] = useState(true);
	
    const toggleTheme = () => {
        const newTheme = !darkMode;
        setDarkMode(newTheme);
        localStorage.setItem('theme', newTheme ? 'dark' : 'light');
		const html = document.documentElement;
		if (html.classList.contains('dark')) {
			html.classList.remove('dark');
			setDarkMode(false);
		} else {
			html.classList.add('dark');
			setDarkMode(true);
		}        
	};

	useEffect(() => {
		if (darkMode) {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
	}, [darkMode]);

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme');
        setDarkMode(savedTheme === 'dark');
      }, []);
      


	return (
        <Router>
            <ScrollToTop />
            <div className={`font-sans ${darkMode ? 'bg-bg-dark text-text-dark' : 'bg-bg-light text-text-light'} min-h-screen`}>
              <Header darkMode={darkMode} toggleTheme={toggleTheme} />
              <main className="pt-20"> 
                <Switch>
                    <Route exact path="/">
                        <WelcomeSection />
                        <AboutUs/>
                        <VisionaryLeader />
                        <ModulesSession />
                        <ClientsSection />
                        <FAQ /> 
                    </Route>
                    <Route path="/know-more">
                        <KnowMore />
                    </Route>
                    <Route path="/register">
                    <SignUpCollege />
                    </Route>
                </Switch>
              </main>
                <Footer />
            </div>
        </Router>
	);
};

export default HomePage;
